// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_38-1";
export var movingGradient = "_38-4";
export var movingGradientBlock = "_38-2";
export var skeleton = "_38-0";
export var skeletonText = "_38-3";